module.exports = __webpack_public_path__ + "img/hero.d3dd3de4.png";